import { createRoutine } from 'redux-saga-routines';
import type { SnackBarType } from './reducers';

export interface SnackBarAddTrigger {
  id?: string;
  name?: string;
  type?: SnackBarType;
  message: string;
  headline?: string;
  lifeTime?: number; // Milliseconds
  isLoading?: boolean;
  actionLabel?: string;
  reducerAction?: ReducerAction;
  secondaryActionLabel?: string;
  secondaryReducerAction?: ReducerAction;
}

export const addSnackBar = createRoutine<
  SimplePayloadCreator<SnackBarAddTrigger>, // trigger
  SimplePayloadCreator<any>, // request
  SimplePayloadCreator<any>, //success
  SimplePayloadCreator<any>, // failure
  SimplePayloadCreator<any> // fulfill
>('@SNACKBAR/ADD', {});

export interface SnackBarRemoveTrigger {
  id: string;
}

export const removeSnackBar = createRoutine<
  SimplePayloadCreator<SnackBarRemoveTrigger>, // trigger
  SimplePayloadCreator<any>, // request
  SimplePayloadCreator<any>, //success
  SimplePayloadCreator<any>, // failure
  SimplePayloadCreator<any> // fulfill
>('@SNACKBAR/REMOVE', {});

export const clearSnackBar = createRoutine('@SNACKBAR/CLEAR');
